import { bool, func, node, string } from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components";

import { toolbarButtonSize } from "NavBar/styleConstants";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import { marketingColors } from "UI/colors";

import dynBackgroundColor from "Utilities/interpolations/dynBackgroundColor";
import flash from "Utilities/interpolations/flash";

const Button = forwardRef(
  (
    {
      children,
      color = marketingColors.fnBlue,
      isFlashing,
      showPopover,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <SFnrShineButton
        ref={ref}
        onClick={onClick}
        $backgroundColor={color}
        $isFlashing={isFlashing && !showPopover}
        showPopover={showPopover}
        {...props}
      >
        <ContentWrapper>
          {children}
        </ContentWrapper>
      </SFnrShineButton>
    );
  }
);

const SFnrShineButton = styled(FnrShineButton)`
  border-radius: 50%;
  ${dynBackgroundColor}
  ${flash}

  &:focus-visible {
    ${dynBackgroundColor}
  }
`;

const ContentWrapper = styled.div`
  width: ${toolbarButtonSize}px;
  height: ${toolbarButtonSize}px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
`;

Button.propTypes = {
  children: node,
  color: string,
  isFlashing: bool,
  showPopover: bool,
  onClick: func,
};

export default Button;
